// extracted by mini-css-extract-plugin
export default {"list":"TreatmentList--list--d9f332","selectAllCheckbox":"TreatmentList--selectAllCheckbox--950c16"};